"use client";
import { useAtomValue, useSetAtom } from "jotai";
import React, { Fragment, Suspense, lazy, useCallback } from "react";
import styled from "styled-components";
import { contextMenuAtom } from "../../store/layoutStore";
import { userAtom } from "../../store/userAtom";
import { Dot, FlexRow } from "../../styles/globalsStyles";
import { RouteInfo } from "../../utils/clientRoutes";
import { StyledLink } from "../StyledLink";
import { NavbarProps } from "./Navbar";
import { StyledNavbar } from "./navbar.styles";
const UserNameToolbar = lazy(() => import("./UserNameToolbar"));

const RoutesWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
`;

const NavbarDesktop = ({ routes, image }: NavbarProps) => {
  const setContextMenu = useSetAtom(contextMenuAtom);
  const user = useAtomValue(userAtom);
  const handleOpenSubMenu = useCallback(
    (
      routeInfo: RouteInfo,
      e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
      e.preventDefault();
      if (!routeInfo.subRoutes) return;

      setContextMenu({
        position: { left: e.clientX, top: e.clientY },
        items: routeInfo.subRoutes.map((subRoute) => ({
          label: subRoute.text,
          route: subRoute.href
        }))
      });
    },
    [setContextMenu]
  );

  return (
    <Suspense>
      <StyledNavbar $isMobile={false}>
        <RoutesWrapper>
          {routes.map((route, index) => (
            <Fragment key={`${index}--allRoutes-navbar`}>
              {index > 0 && <Dot />}

              <StyledLink
                onClick={(e) =>
                  route.subRoutes ? handleOpenSubMenu(route, e) : ""
                }
                route={route}
                fontSize={"medium"}
              />
            </Fragment>
          ))}
        </RoutesWrapper>
        {image && (
          <FlexRow $alignItems="center" $gap={"1rem"}>
            {user && <UserNameToolbar />}
            {image}
          </FlexRow>
        )}
      </StyledNavbar>
    </Suspense>
  );
};

export default NavbarDesktop;
